
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import InlineFormTreeselect from "../../../../../landing/src/molecules/form/InlineFormTreeselect.vue";
import { ServiceTypeStore } from "../../../../../common/src/stores/ServiceTypeStore";
import TreeGroup from "../../components/TreeGroup.vue";
import Loader from "../../components/Loader.vue";

@Component({
    components: {
        InlineFormTreeselect,
        Loader,
        TreeGroup,
    },
})
export default class ServiceFilter extends Vue {
    @Inject("container") readonly container!: Container;
    @Prop() filterStore!: any;
    @Prop() serviceTypeStore!: ServiceTypeStore;

    focused = false;

    get serviceOptions() {
        return this.serviceTypeStore.item || [];
    }

    toggleServices(serviceFilterSet: string[]) {
        this.filterStore.serviceTags = new Set(serviceFilterSet);
    }

    get filterCount() {
        let count = 0;
        count += this.getCount(this.filterStore.serviceTags);
        return count;
    }

    getCount(list: Set<any> | undefined) {
        return list ? list.size : 0;
    }

    changeFocus(val: boolean) {
        this.focused = val;
    }
}
